import Component from 'vue-class-component'
import IconButton from '@/components/buttons/richmenu/IconButton';

@Component({
  name: 'underline-button',
})
export default class UnderlineButton extends IconButton {
}
